import { PaginationTotal, SizePerPageButton } from '../components';
export const paginationOptions = (total) => ({
    sizePerPage: 10,
    page: 1,
    alwaysShowAllBtns: true,
    hideSizePerPage: false,
    hidePageListOnlyOnePage: true,
    showTotal: true,
    paginationTotalRenderer: PaginationTotal,
    sizePerPageRenderer: SizePerPageButton,
    sizePerPageList: [
        {
            text: '10',
            value: 10,
        },
        {
            text: '25',
            value: 25,
        },
        {
            text: 'All',
            value: total,
        },
    ],
});
